import React from "react";
import { Route, Routes } from 'react-router-dom'
import OperExped from "../pages/dashboards/cdc-oper-exped/OperExped";
import OperTransp from "../pages/dashboards/cdc-oper-transp/OperTransp";
import Strategic from "../pages/dashboards/cdc-strategic/Strategic";
import Tatic from "../pages/dashboards/cdc-tatic/Tatic";
import Checklist from "../pages/dashboards/checklist/Checklist";
import PerformanceTelemetria from "../pages/dashboards/performance-telemetria/PerformanceTelemetria";



const DashboardRoutes = (props) => {
    return (
        <Routes>
            <Route
                exact
                path={"/dashboard/weekly-follow-up"}
                element={<PerformanceTelemetria token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/dashboard/checklist"}
                element={<Checklist token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/dashboard/cdc-strategic"}
                element={<Strategic token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/dashboard/cdc-operational-expedition"}
                element={<OperExped token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/dashboard/cdc-operational-transport"}
                element={<OperTransp token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path={"/dashboard/cdc-tatic"}
                element={<Tatic token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            
            
        </Routes>
    )
}

export default DashboardRoutes